export const iconFontAwesomeArrowsArrowsToEye = (
	<i className="fa-solid fa-arrows-to-eye"></i>
);
